angular.module("app").directive("globalMonthlyColorSentiment", () => {
  let link = (scope) => {

  };

  return {
    restrict: "E",
    templateUrl: "app/directives/dbGlobalColorData/globalDailyColor/globalMonthlyColorSentiment/globalMonthlyColorSentimentView.html",
    link: link,
    scope: {
      data: "=",
    }
  };
});
